import styled from 'styled-components'
import Pre from '../Pre'
import { Selector } from './Selectors'

const TabsComp = styled(Selector)``

const TabComp = styled.div<{ selected?: string | null; 'data-option': '' }>`
  ${TabsComp} > &[role='tabpanel'] {
    outline: none;
    display: none;
    pointer: auto;
  }
  ${TabsComp} > &[role='tabpanel'][selected] {
    display: block;
  }
`

export const CodeTabs = { Tabs: TabsComp, Tab: TabComp }

export const Wrapper = styled.div`
  margin-top: 40px;
  position: relative;
`

export const Pree = styled(Pre)`
  margin-top: 12px !important;
  margin-bottom: 0 !important;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  .placeholder {
    font-size: 14px;
    font-weight: 500;
    color: ${p => p.theme.primary} !important;
    background: white;
    border-radius: 4px;
    box-shadow: 0px 1px 2px rgba(12, 52, 75, 0.1);
    padding: 6px;
    cursor: default;
    position: relative;
    z-index: 2;
  }
`
